<template>
  <transition name="fade">
    <div v-show="showModel" class="common-popup" @click="maskClick">
      <div class="common-box" :class="position">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
const COMPONENT_NAME = 'common-popup';
export default {
  name: COMPONENT_NAME,
  data() {
    return {
      showModel: false,
    };
  },
  props: {
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },

    position: {
      type: String,
      default: 'middle',
    },
  },
  beforeMount() {},

  mounted() {},

  methods: {
    show() {
      this.showModel = true;
    },

    hide() {
      this.showModel = false;
    },

    maskClick() {
      if (this.closeOnClickModal) {
        this.hide();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.common-popup {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6); //必须是rgba,否则安卓不支持
}

.common-box {
  position: fixed;
  left: 0;
  width: 100%;
  border-radius: 8px;
}

.middle {
  top: 20%;
}

.top {
  top: 0;
}

.bottom {
  bottom: 0;
}
</style>
